import countries from '../config/countries.json';

export const allowAttachments = formData =>
  !!formData.categoryAllowAttachments &&
  !!formData.topicAllowAttachments &&
  (formData.subtopicAllowAttachments === undefined ||
    !!formData.subtopicAllowAttachments);

export const ADDRESS_TYPES = {
  domestic: 'DOMESTIC',
  international: 'INTERNATIONAL',
  military: 'OVERSEAS MILITARY',
};

export function formatAddress(address) {
  /* eslint-disable prefer-template */
  const {
    country,
    countryCodeIso3,
    countryName,
    postalCode,
    state,
    street,
    street2,
    addressLine1,
    addressLine2,
    addressLine3,
    addressType,
    city,
    stateCode,
    zipCode,
    militaryAddress,
  } = address || {};

  const { militaryPostOffice, militaryState } = militaryAddress || {};

  let cityStateZip = '';

  const countryCode = country || countryCodeIso3;

  const displayCountry = countries.find(c => c.countryCodeISO3 === countryCode);

  const displayCountryName = countryName || displayCountry?.countryName;
  const zip = postalCode || zipCode;

  // Show country for international addresses or non-US country codes
  const isInternational =
    addressType === ADDRESS_TYPES.international ||
    (countryCode && countryCode !== 'USA' && countryCode !== 'US');
  const addressCountry = isInternational ? displayCountryName : '';

  const addressStreet = street
    ? [street, street2].filter(Boolean).join(' ')
    : [addressLine1, addressLine2, addressLine3].filter(Boolean).join(' ');

  // only use the full state name for military addresses, otherwise just show
  // the two-letter state code
  const stateName = state || stateCode || militaryState;

  cityStateZip = city || militaryPostOffice || '';
  if ((city || militaryPostOffice) && stateName) cityStateZip += ', ';
  if (stateName) cityStateZip += stateName;
  if (zip) cityStateZip += ' ' + zip;

  const line1 = addressStreet?.trim() || '';
  const line2 = [cityStateZip, addressCountry]
    .map(s => s?.trim())
    .filter(Boolean)
    .join(' ');

  return { street: line1, cityStateZip: line2 };
}
